/**
 * GitHub Connection Status Hook
 *
 * Fetches the org's GitHub integration status. Used by the sandbox list page
 * and `useGitHubRepositories` to gate UI on whether GitHub is connected.
 *
 * @module features/sandboxes/hooks/useGitHubConnectionStatus
 */

import { useQuery } from '@tanstack/react-query';
import { API_URL } from '../../../config';

type GitHubConnectionStatus = {
  ok: boolean;
  accountLogin?: string;
  accountType?: string;
  installationId?: number;
  error?: string;
};

export function useGitHubConnectionStatus() {
  return useQuery({
    queryKey: ['github-status'],
    queryFn: async (): Promise<GitHubConnectionStatus> => {
      const res = await fetch(`${API_URL}/integrations/github/status`, {
        credentials: 'include',
      });
      return res.json();
    },
  });
}
